if(typeof FN == 'undefined') FN = {};


FN.tocNavigationConfig = {
  selectors: {
    baseContainerTop: 'nav.toc-content--top',
    baseContainerBottom: 'nav.toc-content--bottom',
    tocLinkTop: '.toc-link',
    tocLinkBottom: '.toc-link',
    dropdownContainer: '.toc-dropdown',
  }
}


FN.tocNavigation = {
  init: function() {
  	$(FN.tocNavigationConfig.selectors.baseContainerTop + ' ' + FN.tocNavigationConfig.selectors.tocLinkTop).on('click', FN.tocNavigation.toggleDropdown);
  	$(FN.tocNavigationConfig.selectors.baseContainerBottom + ' ' + FN.tocNavigationConfig.selectors.tocLinkBottom).on('click', FN.tocNavigation.jumpToDropdown);
  },
  
  jumpToDropdown: function(event) {
    event.preventDefault();
    event.stopPropagation();
    
		$('html, body').animate({
			scrollTop: ($(FN.tocNavigationConfig.selectors.baseContainerTop).offset().top - 60)
		}, 300);

		if(FN.tocNavigation.isDropdownVisible() === false){
      FN.tocNavigation.__showDropdown();
  	}
  },
  
  toggleDropdown: function(event){
    event.preventDefault();
    event.stopPropagation();

    if(FN.tocNavigation.isDropdownVisible()){
      FN.tocNavigation.__hideDropdown();
    }else{
      FN.tocNavigation.__showDropdown();
    }
  },
  
  __showDropdown: function() {
  	$(FN.tocNavigationConfig.selectors.baseContainerTop).addClass('active');
  	$(FN.tocNavigationConfig.selectors.baseContainerTop + ' ' + FN.tocNavigationConfig.selectors.tocLinkTop).addClass('active');
  	$(FN.tocNavigationConfig.selectors.baseContainerTop + ' ' + FN.tocNavigationConfig.selectors.dropdownContainer).addClass('visible');
    
		$('html').on('click.tocNavigationHider', FN.tocNavigation.__hideDropdown);
  },
  
  __hideDropdown: function(){
  	$(FN.tocNavigationConfig.selectors.baseContainerTop).removeClass('active');
  	$(FN.tocNavigationConfig.selectors.baseContainerTop + ' ' + FN.tocNavigationConfig.selectors.tocLinkTop).removeClass('active');
  	$(FN.tocNavigationConfig.selectors.baseContainerTop + ' ' + FN.tocNavigationConfig.selectors.dropdownContainer).removeClass('visible');

		$('html').off('click.tocNavigationHider');
  },
  
  isDropdownVisible: function() {
    var isVisible = $(FN.tocNavigationConfig.selectors.baseContainerTop + ' ' + FN.tocNavigationConfig.selectors.tocLinkTop).hasClass('active');
    return isVisible;
  }
  
};




$(document).ready(function(){
  FN.tocNavigation.init();
});
